
import {Vue, Component, Prop} from "vue-property-decorator";
import RelayBoxLocations from "@/components/relays/RelayBoxLocations.vue";
import PrimaryCodeManagement from "@/components/box/PrimaryCodeManagement.vue";
import RelayCreateOrEditBox from "@/components/relays/RelayCreateOrEditBox.vue";
import BoxDeletingModal from "@/components/BoxDeletingModal.vue";
import SvgIcon from "@jamescoyle/vue-icon";
import {mdiPackageVariant, mdiAccessPointNetwork, mdiDelete, mdiBatteryAlertVariantOutline } from "@mdi/js";
import { CONNECTED_BOX_PROVIDERS } from "@/utils/connectedBoxes";
import { Getter } from "vuex-class";
import { getTokenLink } from "@/utils/misc";

@Component({
  components: {
    RelayBoxLocations,
    RelayCreateOrEditBox,
    BoxDeletingModal,
    SvgIcon,
    PrimaryCodeManagement,
  },
})

export default class RelayBox extends Vue {


  get boxDimensions(): number {
    return this.box ? this.box.sheets * this.box.columns * this.box.lines : 0;
  }

  get lang(): string {
    return this.$root.$i18n.locale;
  }

  get canGenerateQrCode(): boolean {
    return !this.box?.ConnectedBox;
  }

  get canPrintAllQrCode(): boolean {
    return this.isAdmin &&
      (!this.box?.ConnectedBox || this.box.ConnectedBox.provider === CONNECTED_BOX_PROVIDERS.SNAPACCESS);

  }
  get canDisplayCodePrimary(): boolean {
    return this.canDoInEnvCompany("MANAGE_PRIMARY_CODE") &&
      this.box?.ConnectedBox && this.box.ConnectedBox.provider === CONNECTED_BOX_PROVIDERS.SNAPACCESS;
  }
  get shouldAlertBattery(): boolean {
    const changedAt = this.box?.ConnectedBox?.changedBatteryAt;
    const provider = this.box?.ConnectedBox?.provider;
    if (!changedAt || provider !== CONNECTED_BOX_PROVIDERS.SNAPACCESS) {
      return false;
    }
    const twoAndHalfYearsAgo = new Date();
    twoAndHalfYearsAgo.setMonth(twoAndHalfYearsAgo.getMonth() - 30); // 2.5 years = 30 months
    return new Date(changedAt) <= twoAndHalfYearsAgo;
  }
  get isMasterlockBox(): boolean {
    return this.box?.ConnectedBox && this.box.ConnectedBox.provider === CONNECTED_BOX_PROVIDERS.SNAPACCESS;
  }

  @Prop({default: null})
  public relay: any;

  @Prop()
  public buildingId: number;

  @Prop({default: null})
  public box: any;

  @Prop({default: 0})
  public index: number;

  @Prop({default: 0})
  public minimumKeys: number;

  @Prop({default: () => ({})})
  public availableOptions: any;

  @Prop({default: false})
  public hasEditRight: boolean;

  public showMoreTags: boolean = false;
  public showPrimaryCodeManagement: boolean = false;
  public isDeleteBoxQrCode: boolean = true;
  public confirmBlock: boolean = false;
  public mdiDelete = mdiDelete;

  @Getter private canDoInEnvCompany: (right: string) => boolean;
  @Getter private isMobile: boolean;
  @Getter private isAdmin: boolean;

  private loadingLocations: boolean = true;
  private showLocations: boolean = false;
  private loadingBoxQrCode: boolean = false;
  private boxLocations: any[] = [];
  private boxTags: any[] = [];
  private mdiPackageVariant = mdiPackageVariant;
  private mdiAccessPointNetwork = mdiAccessPointNetwork;
  private mdiBatteryAlertVariantOutline = mdiBatteryAlertVariantOutline;
  private readonly getTokenLink = getTokenLink;
  public openBoxDeleteDialog(): void {
    this.confirmBlock = true;
  }
  public closeBoxDeleteDialog(): void {
    this.confirmBlock = false;
  }

  private displayLocationsDialog(): void {
    this.getLocations();
    this.showLocations = true;
  }

  private managePrimaryCode(): void {
    this.showPrimaryCodeManagement = true;
  }

  private updateBattery(): void {
    this.$router.push({
      name: "connected-box-update-battery",
      params: { id: this.box.ConnectedBox.id },
      query: { from: this.$route.fullPath },
    });
  }

  private displayStockTag(): void {
    Promise.all([
      this.getLocations(),
      this.getBoxTags(),
    ]).then(() => {
      this.showMoreTags = true;
    });
  }

  private getLocations(): Promise<any> {
    return this.$store.dispatch("boxes/getLocations", {
      id: this.box.id,
    }).then((data) => {
      this.boxLocations = data?.rows || [];
    }).finally(() => {
      this.loadingLocations = false;
    });
  }

  private getBoxTags(): Promise<any> {
    return this.$store.dispatch("boxes/getTags", {
      boxId: this.box.id,
    }).then((data) => {
      this.boxTags = data;
    });
  }

  private closeLocationsDialog(): void {
    this.showLocations = false;
  }

  private generateBoxQrCode(): void {
    this.loadingBoxQrCode = true;
    this.$store.dispatch("boxes/generateBoxQrCode", {
      id: this.box.id,
    }).then(() => {
      this.$emit("reset");
    }).catch((error) => {
      this.$store.commit("alerts/displayHttpError", { error });
    }).finally(() => {
      this.loadingBoxQrCode = false;
    });
  }
  private deleteBoxQrCode(): void {
    this.$store.dispatch("boxes/deleteBoxQrCode", {
      id: this.box.id,
    }).then(() => {
        this.$store.commit("alerts/displaySuccess", {
          msg: this.$i18n?.t("actions.qrCodeDeleted"),
        });
        this.$emit("reset");
    },
    )
      .catch((err) => this.$store.commit("alerts/displayError", {
        msg: this.$i18n?.t("actions.unauthorizedQrCodeDelete"),
      }),
      )
      .finally(() => {
        this.isDeleteBoxQrCode = false;
        this.confirmBlock = false;
    });
  }

  private getKeyNbr(tag): number {
    let keyWithExistantTag: number = 0;
    this.boxLocations.forEach((l) => {
      l.KeyLocation.forEach((kl) => {
        if (!kl.endDate) {
          kl.Key.Tags.forEach((t) => {
            if (tag.id === t.id) {
              keyWithExistantTag++;
            }
          });
        }
      });
    });
    return keyWithExistantTag;
  }
}
